// Hülle für Seiten ohne Anmeldung (Passwort vergessen, Link aus der Mail):
// Logo, eine Karte in der Mitte, Abstand für Status- und Home-Leiste der App.
import type { ReactNode } from 'react';
import { Karte } from '../../../gemeinsam/komponenten/Basis';
import { LogoKachel } from '../../firma/komponenten/Logo';

export default function AuthRahmen({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        paddingTop: 'calc(3rem + var(--sicher-oben))',
        paddingBottom: 'calc(3rem + var(--sicher-unten))',
      }}
      className="flex min-h-full items-center justify-center bg-gradient-to-b from-slate-100 to-slate-200 px-4 dark:from-slate-950 dark:to-slate-900">
      <div className="w-full max-w-md">
        <LogoKachel groesse="gross" klasse="mx-auto mb-4 shadow-lg shadow-marke-600/25" />
        <Karte>
          <div className="space-y-4 p-6">{children}</div>
        </Karte>
      </div>
    </div>
  );
}
